import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchFaqs, createFaq, fetchFaqDetail, modifyFaq, deleteFaq, changeStatus } from '../../api/faqApi';

export const getFaqs = createAsyncThunk('faq/getFAQ', async (payload, { rejectWithValue }) => {
  try {
    const response = await fetchFaqs(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const addFaq = createAsyncThunk('faq/addFAQ', async (payload, { rejectWithValue }) => {
  try {
    const response = await createFaq(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const getFaqDetail = createAsyncThunk('faq/getFAQ', async (faqId, { rejectWithValue }) => {
  try {
    const response = await fetchFaqDetail(faqId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
}); 

export const updateFaq = createAsyncThunk('faq/updateFAQ', async (payload, { rejectWithValue }) => {
  try {
    const response = await modifyFaq(payload);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const destroyFaq = createAsyncThunk('faq/deleteFAQ', async (faqId, { rejectWithValue }) => {
  try {
    const response = await deleteFaq(faqId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

export const changeActiveStatus = createAsyncThunk('faq/changeDefaultStatus', async (faqId, { rejectWithValue }) => {
  try {
    const response = await changeStatus(faqId);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response.data);
  }
});

const faqSlice = createSlice({
  name: 'faq',
  initialState: {
    faqs: [],
    isLoading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(getFaqs.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getFaqs.fulfilled, (state, action) => {
        state.isLoading = false;        
        state.faqs = action.payload.data;
      })
      .addCase(getFaqs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
  },
});

export default faqSlice.reducer;
